import { Redacted } from "effect";
import { privateDependencyFailure } from "./private-cause.ts";

export const FindingDispositionDependencyError = /* @__PURE__ */ (() => {
  class FindingDispositionDependencyError extends privateDependencyFailure<FindingDispositionDependencyError>()("FindingDispositionDependencyError", "finding disposition") {}
  return FindingDispositionDependencyError;
})();
export type FindingDispositionDependencyError = InstanceType<typeof FindingDispositionDependencyError>;
export const findingDispositionDependencyError = (cause: unknown) => new FindingDispositionDependencyError({ cause: Redacted.make(cause) });
